import React from 'react'

const BusinessProcessAutomation = () => {
  const NavigateToWorkflow = () => {
    // Open URL in a new tab when the button is clicked
    // window.open('http://65.2.154.169:8001', '_blank')
  }
  return (
    <div
      className='card m-1 text-decoration-none align-items-center text-center'
      style={{
        width: '20rem',
        overflow: 'hidden',
        boxShadow: 'rgb(204, 204, 204) 2px 2px 9px',
        transform: 'scale(1)'
      }}
    >
      <img
        className=' mt-4 w-100px h-100px'
        src='https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/assets/images/bpa.png'
        alt='Integration logo'
      />
      <div className='card-body align-items-center text-center'>
        <h5 className='card-title text-dark'>Business Process Automation</h5>
        <p className='card-text text-muted'>
          Connect your Business account to manage WhatsApp business conversations easily
        </p>
        <button className='btn btn-primary'>Configure</button>
      </div>
    </div>
  )
}
export default BusinessProcessAutomation
